import React from "react";
import withStyles from "components/common/wrappers/withStyles";

const Supportal = ({ color = "white", svgClassname }) => {
  return (
    <svg
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={svgClassname}
    >
      <path
        d="M14 9.66667V5.88889C14 3.12747 11.3137 1.33333 8 1.33333C4.68629 1.33333 2 3.12747 2 5.88889V9.66667M14 9.94444V7.72222C14 6.95517 13.2538 6.33333 12.3333 6.33333C11.4129 6.33333 10.6667 6.95517 10.6667 7.72222V9.94444C10.6667 10.7115 11.4129 11.3333 12.3333 11.3333C13.2538 11.3333 14 10.7115 14 9.94444ZM14 9.94444V12.5C14 13.6966 13.03 14.6667 11.8333 14.6667V14.6667H9.66667M9.66667 14.6667H7.5C6.85567 14.6667 6.33333 14.1443 6.33333 13.5V13.5C6.33333 12.8557 6.85567 12.3333 7.5 12.3333H8C8.92048 12.3333 9.66667 13.0795 9.66667 14V14.6667ZM3.66667 11.3333C2.74619 11.3333 2 10.7115 2 9.94444V7.72222C2 6.95517 2.74619 6.33333 3.66667 6.33333C4.58714 6.33333 5.33333 6.95517 5.33333 7.72222V9.94444C5.33333 10.7115 4.58714 11.3333 3.66667 11.3333Z"
        stroke={color}
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default withStyles(Supportal);
